import * as React from "react";

function SvgDashboardFeed(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 25 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.535 1.813h-2.187C14.933.758 13.813 0 12.5 0s-2.433.758-2.85 1.813H7.465c-.556 0-1.007.406-1.007.906v3.625c0 .5.451.906 1.007.906h10.07c.555 0 1.007-.406 1.007-.906V2.719c0-.5-.452-.906-1.007-.906z"
        fill="#fff"
        fillOpacity={0.8}
      />
      <path
        d="M22.57 3.625h-2.014v2.719c0 1.499-1.356 2.718-3.021 2.718H7.465c-1.665 0-3.02-1.22-3.02-2.718V3.625H2.43c-1.11 0-2.014.814-2.014 1.813v21.75C.417 28.203 1.3 29 2.43 29H22.57c1.13 0 2.013-.796 2.013-1.813V5.438c0-1.016-.884-1.812-2.013-1.812zM12.206 19.673l-4.028 3.625a1.072 1.072 0 01-.713.265c-.257 0-.515-.09-.713-.265L4.74 21.485a.844.844 0 010-1.281 1.089 1.089 0 011.423 0l1.303 1.17 3.315-2.983a1.089 1.089 0 011.424 0 .844.844 0 01.002 1.282zm0-7.25l-4.028 3.625a1.072 1.072 0 01-.713.265c-.257 0-.515-.09-.713-.265L4.74 14.235a.844.844 0 010-1.281 1.089 1.089 0 011.423 0l1.303 1.17 3.315-2.983a1.089 1.089 0 011.424 0 .844.844 0 01.002 1.282zm7.343 9.327H15.52c-.556 0-1.007-.406-1.007-.906s.451-.907 1.007-.907h4.028c.556 0 1.007.406 1.007.907 0 .5-.451.906-1.007.906zm0-7.25H15.52c-.556 0-1.007-.406-1.007-.906s.451-.906 1.007-.906h4.028c.556 0 1.007.405 1.007.906 0 .5-.451.906-1.007.906z"
        fill="#fff"
        fillOpacity={0.8}
      />
    </svg>
  );
}

export default SvgDashboardFeed;
